export function getRestaurantURL(restaurantId = "") {
	return "/restaurante/" + restaurantId;
}

export function getRestaurantCartaURL(restaurantId = "") {
	return "/restaurante/" + restaurantId + "/carta";
}

export function getRestaurantReservaURL(restaurantId = "") {
	return "/reserva/#restaurante=" + restaurantId;
}

export function findRestaurantInHref(href = "") {
	const match = href?.match(/restaurante[/=]([^/?&]+)/);

	if (match && match[1]) {
		return match[1];
	} else {
		return false;
	}
}

export function filterByRestaurantId(
	array = [],
	restaurantId = "",
	field = "relativeDirectory"
) {
	return array.find((node) => node[field].includes(restaurantId));
}
